import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd, MdSettings } from "react-icons/md";
import { Title } from "../../components/Title";
import { BenefitForm, ICreateBenefitValues } from "../../forms";
import {
  BenefitsDocument,
  Benefit,
  useBenefitsQuery,
  useCreateBenefitMutation,
  useDeleteBenefitMutation,
  useUpdateBenefitMutation,
} from "../../graphql";

const Benefits: React.FC = () => {
  const [currentItem, setCurrentItem] = useState<Benefit>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, loading } = useBenefitsQuery();
  const [create] = useCreateBenefitMutation();
  const [update] = useUpdateBenefitMutation();
  const [deleteItem] = useDeleteBenefitMutation();

  const handleCreatEvent = async (data: ICreateBenefitValues) => {
    currentItem
      ? await update({
          variables: {
            id: currentItem.id,
            descriptioin: data.description,
            externalUrlLabel: data.externalUrlLabel,
            title: data.title,
            imageMediaKey: data.image.key,
            externalURL: data.externalURL || "",
          },
          refetchQueries: [
            {
              query: BenefitsDocument,
            },
          ],
        })
      : await create({
          variables: {
            descriptioin: data.description,
            externalUrlLabel: data.externalUrlLabel,
            title: data.title,
            imageMediaKey: data.image.key,
            externalURL: data.externalURL || "",
          },
          refetchQueries: [
            {
              query: BenefitsDocument,
            },
          ],
        });

    onClose();

    setCurrentItem(null);
  };

  const handleDeleteEvent = async (id: number) => {
    await deleteItem({
      variables: {
        id: id,
      },
      refetchQueries: [
        {
          query: BenefitsDocument,
        },
      ],
    });

    onClose();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Shto një përfitim</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BenefitForm
              onSubmit={(data) => handleCreatEvent(data)}
              initialValues={{
                title: currentItem?.rawTitle
                  ? {
                      sq: currentItem.rawTitle.sq,
                      en: currentItem.rawTitle.en,
                      mk: currentItem.rawTitle.mk,
                    }
                  : { sq: "", en: "", mk: "" },
                description: currentItem?.rawDescription
                  ? {
                      sq: currentItem.rawDescription.sq,
                      en: currentItem.rawDescription.en,
                      mk: currentItem.rawDescription.mk,
                    }
                  : { sq: "", en: "", mk: "" },
                externalUrlLabel: currentItem?.rawDescription
                  ? {
                      sq: currentItem.rawExternalUrlLabel.sq,
                      en: currentItem.rawExternalUrlLabel.en,
                      mk: currentItem.rawExternalUrlLabel.mk,
                    }
                  : { sq: "", en: "", mk: "" },
                externalURL: currentItem?.externalURL,
                image: currentItem?.image,
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
        <Title title="Lista e përfitimeve">
          <Button
            rightIcon={<MdAdd />}
            colorScheme="blue"
            variant="outline"
            size="sm"
            onClick={() => {
              setCurrentItem(null);
              onOpen();
            }}
          >
            Shto
          </Button>
        </Title>

        <Alert status="info" marginBottom={4}>
          <AlertIcon />
          <Text>
            Përfitimet janë pjesë e paketave. Këtu menaxhohet lista e
            përfitimeve dhe lidhja me paketën behet në faqen infividuale të saj.
          </Text>
        </Alert>

        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th width={"300px"}>Titulli</Th>
              <Th>Paketat</Th>
              <Th isNumeric></Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.benefits?.map((item) => (
              <Tr key={item.id}>
                <Td>{item.title}</Td>
                <Td>
                  {item.tiers.length
                    ? item.tiers.map((i) => i.name).join(", ")
                    : "Asnjë paketë"}
                </Td>
                <Td isNumeric>
                  <Menu>
                    <MenuButton
                      px={2}
                      py={0.5}
                      transition="all 0.2s"
                      _focus={{ boxShadow: "outline" }}
                    >
                      <MdSettings />
                    </MenuButton>
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setCurrentItem(item as Benefit);
                          onOpen();
                        }}
                      >
                        Redakto
                      </MenuItem>
                      <MenuItem onClick={() => handleDeleteEvent(item.id)}>
                        Fshi
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default Benefits;
